<template lang="html">
  <section class="model_grid_management">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">

          <!-- FILTRI (VISIBILI) -->
          <b-collapse id="model_grid_filters" visible class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>

              <div class="row mb-2">
                <div class="col-lg-3">Model Code:</div>
                <input type="text" class="col-lg-3" v-model="filter.vetele"/>

                <div class="col-lg-3">Model Name:</div>
                <input type="text" class="col-lg-3" v-model="filter.vetdat"/>
              </div>

              <div class="row mb-2">
                <div class="col-lg-3">Range Code:</div>
                <input type="text" class="col-lg-3" v-model="filter.rangeCode"/>

                <div class="col-lg-3">Model Year:</div>
                <input type="number" class="col-lg-3" v-model.number="filter.modelYear"/>
              </div>

              <div class="row mb-2">
                <div class="col-lg-3">Engine Group:</div>
                <input type="text" class="col-lg-3" v-model="filter.engineGroup"/>

                <div class="col-lg-3">Trim:</div>
                <input type="text" class="col-lg-3" v-model="filter.trim"/>
              </div>

              <div class="row mb-3">
                <div class="col-lg-3">My Key:</div>
                <input type="text" class="col-lg-3" v-model="filter.myKey"/>

                <div class="col-lg-3">Fresh Data Grid:</div>
                <b-form-select class="col-lg-3" v-model="freshFilter">
                  <b-form-select-option :value="''">Any</b-form-select-option>
                  <b-form-select-option :value="'0'">Legacy</b-form-select-option>
                  <b-form-select-option :value="'1'">Fresh</b-form-select-option>
                </b-form-select>
              </div>

              <b-button variant="primary" @click="search()">
                <i class="mdi mdi-magnify"></i>Search
              </b-button>
            </b-card>
          </b-collapse>

          <!-- HEADER + PAGINAZIONE -->
          <div class="col-lg-12 card-body row">
            <div class="col-lg-4">
              <h4 class="card-title">Model Grid Management</h4>
            </div>

            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  class="col-lg-9"
                ></b-pagination>

                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <div class="col-lg-4">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable">
                  <i class="mdi mdi-refresh"></i>Refresh Table
                </b-button>
              </span>
            </div>

            <!-- GRIGLIA -->
            <b-table
              ref="model_grid_tab"
              id="table"
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="vetele"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- freshDataGrid come pulsante X/V -->
              <template v-slot:cell(freshDataGridButton)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                    <b-button
                      v-if="!data.item.freshDataGrid"
                      class="col-lg-5 p-1 m-auto"
                      size="sm"
                      style="max-width: 2.875rem;"
                      variant="primary"
                      v-b-tooltip.hover
                      title="Set Fresh"
                      @click="toggleFreshDataGrid(data.item, true)"
                    >
                      <i class="mdi mdi-close-outline btn-outline-secondary" style="display:block;"></i>
                    </b-button>

                    <b-button
                      v-else
                      class="col-lg-5 p-1 m-auto"
                      size="sm"
                      style="max-width: 2.875rem;"
                      variant="primary"
                      v-b-tooltip.hover
                      title="Set Legacy"
                      @click="toggleFreshDataGrid(data.item, false)"
                    >
                      <i class="mdi mdi-check-outline btn-outline-success" style="display:block;"></i>
                    </b-button>
                  </h4>
                </b-row>
              </template>

            </b-table>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import { mapActions, mapGetters } from "vuex";

export default {
  name: "model_grid_management",

  data() {
    return {
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: "vetele",
      sortDesc: false,

      // filtro (body)
      filter: {
        vetele: "",
        vetdat: "",
        rangeCode: "",
        modelYear: null,
        engineGroup: "",
        trim: "",
        myKey: "",
        // freshDataGrid NON nel body: gestito da freshFilter
        freshDataGrid: null
      },

      // filtro UI per freshDataGrid (Any/0/1)
      freshFilter: "",

      items: [],

      fields: [
        { key: "vetele", label: "Model Code", sortable: false },
        { key: "vetdat", label: "Model Name", sortable: false },
        { key: "rangeCode", label: "Range Code", sortable: false },
        { key: "modelYear", label: "Model Year", sortable: false },
        { key: "engineGroup", label: "Engine Group", sortable: false },
        { key: "trim", label: "Trim", sortable: false },
        { key: "myKey", label: "My Key", sortable: false },
        { key: "freshDataGridButton", label: "Fresh Data Grid", sortable: false }
      ]
    };
  },

  computed: {
    ...mapGetters(["authHeader"])
  },

  watch: {
    currentPage() {
      this.refreshTable();
    },
    perPage() {
      this.refreshTable();
    },
    sortBy() {
      this.refreshTable();
    },
    sortDesc() {
      this.refreshTable();
    }
  },

  methods: {
    ...mapActions(["setCurApp", "setSpinnerStatus"]),

    refreshTable() {
      this.search();
    },

    buildFilterBody() {
      // Copia del filtro base
      const body = { ...this.filter };

      // Gestione freshDataGrid: Any / 0 / 1
      if (this.freshFilter === "") {
        body.freshDataGrid = null;
      } else if (this.freshFilter === "1") {
        body.freshDataGrid = true;
      } else if (this.freshFilter === "0") {
        body.freshDataGrid = false;
      }

      // Normalizza modelYear: se vuoto/null non filtrare
      if (!body.modelYear || body.modelYear <= 0) {
        body.modelYear = 0; // coerente con entity int (se usi Integer, puoi mettere null)
      }

      return body;
    },

    search() {
      console.log(this.filter)
      this.setSpinnerStatus(true);

      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      };

      const body = this.buildFilterBody();

      this.axios
        .post("/ccb/auth/fe/ocvet00f/allPaged", body, { params, ...this.authHeader })
        .then((response) => {
          this.items = (response.data && response.data.content) ? response.data.content : [];
          this.totalRowsResult = (response.data && response.data.totalElements) ? response.data.totalElements : 0;
          if (this.$refs.model_grid_tab) {
            this.$refs.model_grid_tab.refresh();
          }
        })
        .finally(() => {
          this.setSpinnerStatus(false);
        });
    },

    toggleFreshDataGrid(item, value) {
      this.$bvModal
        .msgBoxConfirm(
          `Do you want to set this model as ${value ? "Fresh" : "Legacy"} for ${item.vetele}?`,
          {
            title: "Confirm",
            okTitle: "Confirm",
            cancelTitle: "Cancel",
            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            this.saveItem({ ...item, freshDataGrid: value });
          }
        });
    },

    saveItem(item) {
      this.setSpinnerStatus(true);

      this.axios
        .put("/ccb/auth/fe/ocvet00f/update/" + item.vetele, item, this.authHeader)
        .then((response) => {
          if (response && response.status === 200) {
            this.refreshTable();
          }
        })
        .finally(() => {
          this.setSpinnerStatus(false);
        });
    }
  },

  mounted() {
    this.setCurApp("ccadm");
    this.search();
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
}
</style>
